<template>
  <div class="search bg-gray-100">
    <container class="py-12">
      <div class="lg:text-center">
        <head-line :level="1" :size="2" :bold="true" class="mb-4">{{ $t('general.doctors') }}</head-line>
        <p class="text-muted">{{ $t('pages.home.tabs.doctors.description') }}</p>
      </div>
     
      
     <div class="mt-6">
       <div class="search-form lg:text-center">
           <input
            type="search"
            v-model.trim="searchParams.FilterString"
            @input="filterHandler"
            :placeholder="$t('form.placeholder.searchFilter')"
            class="inline-block w-full lg:w-6/12 appearance-none flex-1 bg-white border border-gray-300 hover:border-gray-500 p-4 lg:p-5 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-900"
          />
       </div>
      <div class="my-6 flex justify-end lg:hidden ">
        <button class="flex border-2 text-gray-600 text-sm font-semibold border-transparent items-center justify-between px-3 py-2 w-24 rounded focus:outline-none focus:border-awro-600" style="background: #EEF0F2" @click="hideSidebar = false">
          <svg
          class="text-gray-600 fill-current"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.3 7.7C2.11159 7.51537 2.00376 7.26377 2 7V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H21C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3V7C21.9962 7.26377 21.8884 7.51537 21.7 7.7L15 14.42V17C14.9962 17.2638 14.8884 17.5154 14.7 17.7L10.7 21.7C10.5602 21.837 10.3833 21.93 10.1912 21.9675C9.99905 22.0049 9.80015 21.9852 9.61915 21.9106C9.43815 21.8361 9.283 21.7101 9.17294 21.5482C9.06288 21.3863 9.00275 21.1957 9 21V14.41L2.3 7.71V7.7ZM4 4V6.59L10.7 13.29C10.7945 13.3826 10.8697 13.4931 10.9212 13.6149C10.9727 13.7368 10.9995 13.8677 11 14V18.59L13 16.59V14C13.0038 13.7362 13.1116 13.4846 13.3 13.3L20 6.58V4H4Z"
            />
          </svg>
          <span>{{ $t('filters.filter') }}</span>
        </button>
      </div>
     </div>
      
    </container>

    <container class="py-2 lg:py-12 lg:flex lg:justify-between lg:items-start">
      <aside class="filter-sidebar w-full lg:w-3/12 bg-white shadow rounded-lg p-4 fixed overflow-scroll inset-0 z-50 lg:block lg:sticky lg:overflow-auto" :class="[{ 'ml-8': isRtl }, { 'mr-8': !isRtl }, {'hidden': hideSidebar}]">
        <div class="close absolute transfrom translate-y-4 lg:hidden h-10 w-10" :class="[{ 'left-0': isRtl }, { 'right-0': !isRtl }]" @click="hideSidebar = true">
             <svg class="h-8 w-8 text-support-300 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.24 14.83C16.4038 15.0213 16.4894 15.2674 16.4797 15.519C16.47 15.7707 16.3656 16.0095 16.1876 16.1876C16.0095 16.3656 15.7707 16.47 15.519 16.4797C15.2674 16.4894 15.0213 16.4038 14.83 16.24L12 13.41L9.16999 16.24C8.97869 16.4038 8.73261 16.4894 8.48094 16.4797C8.22926 16.47 7.99052 16.3656 7.81243 16.1876C7.63433 16.0095 7.53 15.7707 7.52028 15.519C7.51056 15.2674 7.59616 15.0213 7.75999 14.83L10.59 12L7.75999 9.16999C7.59616 8.97869 7.51056 8.73261 7.52028 8.48094C7.53 8.22926 7.63433 7.99052 7.81243 7.81243C7.99052 7.63433 8.22926 7.53 8.48094 7.52028C8.73261 7.51056 8.97869 7.59616 9.16999 7.75999L12 10.59L14.83 7.75999C15.0213 7.59616 15.2674 7.51056 15.519 7.52028C15.7707 7.53 16.0095 7.63433 16.1876 7.81243C16.3656 7.99052 16.47 8.22926 16.4797 8.48094C16.4894 8.73261 16.4038 8.97869 16.24 9.16999L13.41 12L16.24 14.83Z"/>
            </svg>
        </div>
        <div class="flex items-baseline">
          <svg
          class="text-awro-600 fill-current"
          :class="[{'ml-2' : isRtl},{'mr-2' : !isRtl}]"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.3 7.7C2.11159 7.51537 2.00376 7.26377 2 7V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H21C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3V7C21.9962 7.26377 21.8884 7.51537 21.7 7.7L15 14.42V17C14.9962 17.2638 14.8884 17.5154 14.7 17.7L10.7 21.7C10.5602 21.837 10.3833 21.93 10.1912 21.9675C9.99905 22.0049 9.80015 21.9852 9.61915 21.9106C9.43815 21.8361 9.283 21.7101 9.17294 21.5482C9.06288 21.3863 9.00275 21.1957 9 21V14.41L2.3 7.71V7.7ZM4 4V6.59L10.7 13.29C10.7945 13.3826 10.8697 13.4931 10.9212 13.6149C10.9727 13.7368 10.9995 13.8677 11 14V18.59L13 16.59V14C13.0038 13.7362 13.1116 13.4846 13.3 13.3L20 6.58V4H4Z"
          />
        </svg>

        <div>
          <head-line :level="3" :size="3" :bold="true" :class="{'mt-2 mb-3': isRtl}">{{ $t('filters.filter') }}</head-line>
          <p class="text-muted">{{ $t('filters.refine') }}</p>
        </div>
        </div>
        
        <hr class="mt-4 mb-8"/>
         
        <div class="widgets mt-2">

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="CityId">
            {{ $t('form.field.city') }}
          </label>
          <div class="relative">
            <select v-model="searchParams.CityId" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" :class="[{'pl-8': isRtl}, {'pr-8': !isRtl}]" id="CityId">
              <option value="" selected>{{ $t('form.placeholder.all') }}</option>
              <option v-for="city in filters.Cities" :value="city.Id" :key="city.Id">{{ city.Name }}</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0  flex items-center px-2 text-gray-700" :class="[{'left-0': isRtl}, {'right-0': !isRtl}]">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="HospitalId">
            {{ $t('filters.hospital') }}
          </label>
          <div class="relative">
            <select v-model="searchParams.HospitalId" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4  rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" :class="[{'pl-8': isRtl}, {'pr-8': !isRtl}]" id="HospitalId">
              <option value="" selected>{{ $t('form.placeholder.all') }}</option>
              <option v-for="hospital in filters.Hospitals" :value="hospital.Id" :key="hospital.Id">{{ hospital.Name }}</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 flex items-center px-2 text-gray-700" :class="[{'left-0': isRtl}, {'right-0': !isRtl}]"> 
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="ClinicId">
             {{ $t('filters.clinic') }}
          </label>
          <div class="relative">
            <select v-model="searchParams.ClinicId" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" :class="[{'pl-8': isRtl}, {'pr-8': !isRtl}]" id="ClinicId">
              <option value="" selected>{{ $t('form.placeholder.all') }}</option>
              <option v-for="clinic in filters.Clinics" :value="clinic.Id" :key="clinic.Id">{{ clinic.Name }}</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0  flex items-center px-2 text-gray-700" :class="[{'left-0': isRtl}, {'right-0': !isRtl}]">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="speciality">
             {{ $t('filters.speciality') }}
          </label>
          <div class="relative">
            <select v-model="searchParams.SpecialityId" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" :class="[{'pl-8': isRtl}, {'pr-8': !isRtl}]" id="speciality">
              <option value="" selected>{{ $t('form.placeholder.all') }}</option>
              <option v-for="speciality in filters.ExpertiseCategories" :value="speciality.Id" :key="speciality.Id">{{ speciality.Name }}</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0  flex items-center px-2 text-gray-700" :class="[{'left-0': isRtl}, {'right-0': !isRtl}]">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="sub-speciality">
             {{ $t('filters.sub-speciality') }}
          </label>
          <div class="relative">
            <select 
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            :class="[{'pl-8': isRtl}, {'pr-8': !isRtl}]"
            id="sub-speciality"
            v-model="searchParams.SubSpecialityId"
            >
              <option value="" selected>{{ $t('form.placeholder.all') }}</option>
              <option v-for="subspeciality in filters.Expertises" :value="subspeciality.Id" :key="subspeciality.Id">{{ subspeciality.Name }}</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0  flex items-center px-2 text-gray-700" :class="[{'left-0': isRtl}, {'right-0': !isRtl}]">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
        </div>
        <div class="w-full mb-6">
          <label class="form-switch">
            <input type="checkbox" v-model="searchParams.HaveTurns">
            <i></i>
            {{ $t('filters.turns') }}
        </label>
        </div>
        <div class="w-full mb-6">
          <search-button 
          @click="applyFilter"
          :full="true"
          >
          {{ $t('filters.filter') }}
          </search-button>
        </div>
        </div> <!-- ./widgets -->
      </aside>

      <div class="result w-full lg:w-9/12" :class="[{ 'lg:-ml-4': isRtl }, { 'lg:-mr-4': !isRtl }]">
        <div class="mb-20 flex items-center" v-if="searchedQueries.length > 0"> <span>{{ $t('search.searchedFor')}} </span>
          <div class="inline-flex text-xs flex-1" :class="[{ 'mr-4': isRtl }, { 'ml-4': !isRtl }]">
              <span v-for="(q, i) in searchedQueries" :key="i" class="param-tag overflow-hidden rounded bg-white inline-flex items-stretch">
                <div @click="removeFilter(q.key)" class="bg-gray-200 inline-flex p-1 select-none cursor-pointer items-center ">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.24 14.83C16.4038 15.0213 16.4894 15.2674 16.4797 15.519C16.47 15.7707 16.3656 16.0095 16.1876 16.1876C16.0095 16.3656 15.7707 16.47 15.519 16.4797C15.2674 16.4894 15.0213 16.4038 14.83 16.24L12 13.41L9.16999 16.24C8.97869 16.4038 8.73261 16.4894 8.48094 16.4797C8.22926 16.47 7.99052 16.3656 7.81243 16.1876C7.63433 16.0095 7.53 15.7707 7.52028 15.519C7.51056 15.2674 7.59616 15.0213 7.75999 14.83L10.59 12L7.75999 9.16999C7.59616 8.97869 7.51056 8.73261 7.52028 8.48094C7.53 8.22926 7.63433 7.99052 7.81243 7.81243C7.99052 7.63433 8.22926 7.53 8.48094 7.52028C8.73261 7.51056 8.97869 7.59616 9.16999 7.75999L12 10.59L14.83 7.75999C15.0213 7.59616 15.2674 7.51056 15.519 7.52028C15.7707 7.53 16.0095 7.63433 16.1876 7.81243C16.3656 7.99052 16.47 8.22926 16.4797 8.48094C16.4894 8.73261 16.4038 8.97869 16.24 9.16999L13.41 12L16.24 14.83Z" fill="#4A5568"/>
                  </svg>

                </div>
                <span class="inline-block py-1 px-2">
                  {{q.value}}
                </span>
              </span>
          </div>
        </div>

        <!-- Loader or Placeholder -->
        <div class="lg:flex lg:flex-wrap" v-if="loading">
           <div 
          :class="[{'pl-4': isRtl}, {'pr-4': !isRtl}]" 
          class="doctor-card w-full lg:w-4/12 mb-8"
          v-for="placeholder in 12"
          :key="placeholder"
          >
            <doctor-placeholder class="py-0"></doctor-placeholder>
           </div>
        </div>

        <!-- Founded doctors -->
        <div class="results lg:flex lg:flex-wrap mt-6" v-if="!loading && doctors.length >= 1">
          <div 
          :class="[{'lg:pl-4': isRtl}, {'lg:pr-4': !isRtl}]" 
          class="doctor-card w-full lg:w-4/12 mb-16 mb-20"
          v-for="doctor in doctors"
          :key="doctor.Id"
          >
            <doctor-card 
            :avatar="doctor.Avatar"
            :full-name="doctor.FullName" 
            :rate="doctor.AverageRating" 
            :speciality="doctor.ExpertiseCategory" 
            :address="doctor.Address"
            class="h-full w-full"
            @more="more"
            ></doctor-card>
          </div>
        </div>

        <div class="load-more text-center mt-6 mb-16" v-if="doctors.length > 0">
           <button
            class="tracking-wide select-none cursor-pointer inline-flex border-0 font-semibold rounded px-6 py-2"
            :class="[{'bg-gray-300 cursor-wait': busy, 'bg-support-700 hover:bg-support-300 shadow ': !busy && !maxLoad}, {'text-gray-400 bg-gray-200': maxLoad}, {'text-awro-100': !maxLoad}]"
            @click.prevent="loadMore" 
            :disabled="busy || maxLoad"
           >

            <svg v-if="busy" width="20" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#999">
            <g fill="none" fill-rule="evenodd">
                <g transform="translate(1 1)" stroke-width="2">
                    <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                    <path d="M36 18c0-9.94-8.06-18-18-18">
                        <animateTransform
                            attributeName="transform"
                            type="rotate"
                            from="0 18 18"
                            to="360 18 18"
                            dur="1s"
                            repeatCount="indefinite"/>
                    </path>
                </g>
            </g>
          </svg>
          <span v-if="!busy" :class="[{'ml-3': !isRtl && busy},{'mr-3': isRtl && busy}]">
                {{ $t('btn.loadMore') }}
          </span>
        </button>
        </div>

        <!-- Not found -->
        <div v-if="!loading && doctors.length <= 0" class="text-center mb-16">
          <div class="inline-block mb-4">
           <img src="@/assets/images/no-result.svg" alt="" style="max-width: 300px; width: 100%">
          </div>
          <head-line :level="4" :size="4" :bold="true" class="mb-2">{{ $t("search.noresult-title") }}</head-line>
          <p class="text-muted">{{ $t("search.noresult-description") }} <strong class="text-gray-700">{{searchParams.FilterString}}</strong>.</p>
        </div>
        <!-- ./results -->
      </div>
    </container>

    <!-- Mobile app download modal -->
    <transition name="fade">
      <div class="mobile-modal w-full h-full fixed inset-0 z-50 flex flex-col justify-center items-center text-center px-4" v-if="showMobileModal">
      <div class="bg-gray-600 absolute inset-0 w-full h-full opacity-75" @click="showMobileModal = false"></div>
       <div class="relative bg-white p-12 shadow-lg rounded overflow-hidden">

          <div class="absolute w-12 h-12 bg-white flex justify-center items-center rounded-l-md top-0 cursor-pointer" :class="[{'right-0' : isRtl},{'left-0' : !isRtl}]" @click="showMobileModal = false">
            <svg class="h-8 w-8 text-support-300 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.24 14.83C16.4038 15.0213 16.4894 15.2674 16.4797 15.519C16.47 15.7707 16.3656 16.0095 16.1876 16.1876C16.0095 16.3656 15.7707 16.47 15.519 16.4797C15.2674 16.4894 15.0213 16.4038 14.83 16.24L12 13.41L9.16999 16.24C8.97869 16.4038 8.73261 16.4894 8.48094 16.4797C8.22926 16.47 7.99052 16.3656 7.81243 16.1876C7.63433 16.0095 7.53 15.7707 7.52028 15.519C7.51056 15.2674 7.59616 15.0213 7.75999 14.83L10.59 12L7.75999 9.16999C7.59616 8.97869 7.51056 8.73261 7.52028 8.48094C7.53 8.22926 7.63433 7.99052 7.81243 7.81243C7.99052 7.63433 8.22926 7.53 8.48094 7.52028C8.73261 7.51056 8.97869 7.59616 9.16999 7.75999L12 10.59L14.83 7.75999C15.0213 7.59616 15.2674 7.51056 15.519 7.52028C15.7707 7.53 16.0095 7.63433 16.1876 7.81243C16.3656 7.99052 16.47 8.22926 16.4797 8.48094C16.4894 8.73261 16.4038 8.97869 16.24 9.16999L13.41 12L16.24 14.83Z"/>
            </svg>
        </div>

         <p class="mb-4 text-secondary-700">{{ $t('alert.mobile.booking') }}</p>
          <h3 class="text-xl lg:text-4xl font-bold" v-html="$t('alert.mobile.msg')"></h3>
          <div class="mt-10 text-center">
            <a href="https://apps.apple.com/us/app/awronore/id1481781235" class="mb-4 lg:mb-0 lg:mx-2 block lg:inline-block" rel="nofollow" target="_blank">
              <img src="@/assets/images/appstore.jpg" alt="" class="inline-block">
            </a>
            <a href="https://play.google.com/store/apps/details?id=krd.awrosoft.awronore" class="lg:mb-0 lg:mx-2 block lg:inline-block" rel="nofollow" target="_blank">
              <img src="@/assets/images/playstore.jpg" alt="" class="inline-block">
            </a>
          </div>
       </div>
    </div>
    </transition>

    <!-- Scroll to top -->
    <div class="w-16 h-16 bg-support-700 fixed bottom-0 right-0 mr-3 mb-3 lg:mr-6 lg:mb-6 rounded-full flex justify-center items-center select-none cursor-pointer" ref="scrollBtn" @click="scrollToTop" :class="{'hidden': shouldHideScrollBtn}">
      <svg class="text-awro-700 fill-current flex-1 w-10 h-10"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M8.7001 14.7C8.50753 14.8444 8.26932 14.9145 8.02921 14.8975C7.7891 14.8804 7.5632 14.7773 7.39299 14.6071C7.22278 14.4369 7.11968 14.211 7.10261 13.9709C7.08555 13.7308 7.15567 13.4926 7.3001 13.3L11.3001 9.3C11.487 9.11678 11.7383 9.01414 12.0001 9.01414C12.2619 9.01414 12.5132 9.11678 12.7001 9.3L16.7001 13.3C16.8445 13.4926 16.9146 13.7308 16.8976 13.9709C16.8805 14.211 16.7774 14.4369 16.6072 14.6071C16.437 14.7773 16.2111 14.8804 15.971 14.8975C15.7309 14.9145 15.4927 14.8444 15.3001 14.7L12.0001 11.42L8.7001 14.72V14.7Z"/>
      </svg>
    </div>
  </div>
</template>

<script>
import Container from "@/components/Container"
import { mapGetters } from "vuex"
import HeadLine from "@/components/theme/HeadLine"
import { debounce, keys, has } from "lodash"
import SearchButton from '@/components/SearchButton'
import DoctorCard from '@/components/DoctorCard'
import DoctorPlaceholder from '@/components/DoctorPlaceholder'
import Api from '@/api'

export default {
  name: "Search",
  components: { Container, HeadLine, SearchButton, DoctorCard, DoctorPlaceholder },
  async beforeRouteEnter(to, from, next) {
    next( async (vm) => {
      vm.loading = true;
      vm.setData(vm.$route.query);
      await vm.getDoctors(vm.searchParams);
      vm.loading = false;
    });
  },
  async beforeRouteUpdate(to, from, next) {
    this.setData(to.query);
    this.loading = true;
    this.getDoctors({...this.searchParams, page: to.query.page}).then( () => {
      this.loading = false;
    });
    next();
  },
  created() {
    this.setData(this.$route.query);
    this.$store.dispatch('filters/FETCH_FILTERS');
  },
  mounted() {
    this.scrollBtnHandler()
    window.addEventListener('scroll', debounce(this.scrollBtnHandler.bind(this), 200))
  },
  beforeDestroy() {
    window.removeEventListener('scroll',  debounce(this.scrollBtnHandler.bind(this), 200))
  },
  data() {
    return {
      searchParams: {
        FilterString: "",
        CityId: "",
        CenterType: 0,
        HospitalId: "",
        ClinicId: "",
        SpecialityId: "",
        SubSpecialityId: "",
        HaveTurns: false,
        ServiceId: 1,
      },
      error: null,
      doctors: [],
      page: 0,
      total: 0,
      busy: false,
      shouldHideScrollBtn: true,
      loading: false,
      hideSidebar: true,
      showMobileModal: false
    };
  },
  computed: {
    ...mapGetters({
      isRtl: ["locale/IS_RTL"],
      filters: ['filters/FILTERS']
    }),
    maxLoad() {
      return this.doctors.length >= this.total;
    },
    searchedQueries() {
      const whitelist = [
        'FilterString'
      ]

      let keys = Object.keys(this.$route.query)
      .filter( key => {
        return (
          whitelist.indexOf(key) !== -1 &&  ( Array.isArray(this.$route.query[key]) || this.$route.query[key].trim() != ''))
      })
      .map((key) => ({
            key,
            value: this.$route.query[key]
      }));
     return keys;
      
    },
  },
  methods: {
    setData(query) {
      const newQuery = {};
      for (const prop of keys(query)) {
        if (has(this.searchParams, prop)) {
          newQuery[prop] = query[prop];
        }
      }
      this.searchParams = { ...this.searchParams, ...newQuery };
      this.searchParams.HaveTurns = (this.searchParams.HaveTurns == 'true' || this.searchParams.HaveTurns == true) ? true : false;
     // this.searchParams.Expertises = [this.searchParams.Expertises];
    },
    filterHandler: debounce(function() {
      this.applyFilter() 
    }, 800),
    applyFilter() {
      this.hideSidebar = true
      this.$router
          .replace({
            name: "SearchDoctor",
            query: { ...this.$route.query, ...this.searchParams },
          });

    },
    removeFilter(filter) {
      this.searchParams[filter] = '';
      this.$router.replace({
        name: 'SearchDoctor',
        query: {...this.searchParams}
      })
    },
    async getDoctors(query) {
      const page = query.page || 0;
      this.loading = true;
      let resp = await Api.post('/doctors/' + page + '/10', query);
      this.doctors = resp.data.Doctors;
      this.total = resp.data.TotalCount
      this.loading = false;

    },
    more() {
      this.showMobileModal = true;
    },
    async loadMore() {
      if(this.doctors.length  >= this.total)  return;
      if('onLine' in window.navigator && !window.navigator.onLine) return;

      this.page++;
      this.busy = true
      
      let resp = await Api.post('/doctors/' + this.page + '/10', this.searchParams)
      this.doctors = [...this.doctors, ...resp.data.Doctors]
      this.busy = false;

    },
    scrollToTop() {
      window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth'
      });
  },
  scrollBtnHandler() {
    if(window.pageYOffset > 800) {
      this.shouldHideScrollBtn = false;
      return;
    }
    this.shouldHideScrollBtn = true;
  }
  },
  watch: {
    '$i18n.locale': function () {
      let query = this.$route.query;

      if(Object.keys(query).length <= 0) {
        query = this.searchParams;
      }
      this.getDoctors(query);
      this.$store.dispatch('filters/FETCH_FILTERS');
    }
  },
  metaInfo() {
    let titleTemplate = '%s';
    if(this.searchParams.FilterString != '' ) {
      titleTemplate = '%s | ' + this.searchParams.FilterString;
    }

    return {
      title: this.$i18n.t('pages.search.title'),
      titleTemplate,
      htmlAttrs: {
        amp: true,
        lang: this.$i18n.locale
      } 
    } 

  },
};
</script>

<style>
  html {
    scroll-behavior: smooth;
  }

  .param-tag:nth-child(1n+ 2) {
    margin-left: 6px;
  }
  @media screen  and (min-width: 1023px){
    .filter-sidebar {
      position: sticky;
      top: 32px;
    }
  }

  .form-switch {
  display: inline-block;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.form-switch i {
  position: relative;
  display: inline-block;
  margin-right: .5rem;
  width: 46px;
  height: 26px;
  background-color: #e6e6e6;
  border-radius: 23px;
  vertical-align: text-bottom;
  transition: all 0.3s linear;
}

.form-switch i::before {
  content: "";
  position: absolute;
  left: 0;
  width: 42px;
  height: 22px;
  background-color: #fff;
  border-radius: 11px;
  transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);
  transition: all 0.25s linear;
}

.form-switch i::after {
  content: "";
  position: absolute;
  left: 0;
  width: 22px;
  height: 22px;
  background-color: #fff;
  border-radius: 11px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
  transform: translate3d(2px, 2px, 0);
  transition: all 0.2s ease-in-out;
}

.form-switch:active i::after {
  width: 28px;
  transform: translate3d(2px, 2px, 0);
}

.form-switch:active input:checked + i::after { transform: translate3d(16px, 2px, 0); }

.form-switch input { display: none; }

.form-switch input:checked + i { background-color: #00bfbc; }

.form-switch input:checked + i::before { transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0); }

.form-switch input:checked + i::after { transform: translate3d(22px, 2px, 0); }

</style>
